import { gql } from '@apollo/client';

export const GET_STUDENT_LIST_FOR_SELECTOR = gql`
  query SkWeb_StudentList_2(
    $username: String
    $studentId: ID
    $schoolId: ID
    $productId: ID
    $classroomId: ID
    $search: String
    $page: Int
    $pageSize: Int
    $sortBy: String
    $order: String
  ) {
    studentList(
      username: $username
      studentId: $studentId
      schoolId: $schoolId
      productId: $productId
      classroomId: $classroomId
      search: $search
      page: $page
      pageSize: $pageSize
      sortBy: $sortBy
      order: $order
    ) {
      data {
        id
        name
        username
        englishName
      }
      totalCount
    }
  }
`;
